import React from 'react';
import { Row, Col, Form, FormGroup, Input, FormFeedback } from 'reactstrap';
import {Button} from "../components/button/Button";
import { validateEmail } from "./Validate";
import { connect } from 'react-redux';
import {Spinner} from "../components/spinner/Spinner";

/**
 * BasicForm is a gravityform template component that loads and handles
 * all form actions.
 *
 * IMPORTANT! do not change props.
 */
class BasicFormContainer extends React.Component {

  inputRefs = {};

  constructor(props) {
    super(props);

    this.submit = this.submit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.checkValidity = this.checkValidity.bind(this);

    this.state = {
      values: {},
      valid: {},
      submitted: false,
      message: null,
      sending: false
    };

    this.props.gravityFormsApi
      .get(`forms/${this.props.formId}`)
      .then( response => response.json())
      .then(
        ( { response } ) => {
          this.setState({
            fields: response.fields,
            button: response.button
          });
        },
        error => {
        }
      );
  }

  submit(event){
    event.preventDefault();
    const { valid } = this.state;

    // Check validity
    if(this.state.fields
        .map( f => {
          const v = this.checkValidity(f);
          valid[f.id] = v;
          return v;
        })
        .find( o => !o )){
      return;
    }

    this.setState({ submitted: true, valid, sending: true });

    const data = {
      input_values: {}
    };

    Object.keys(this.state.values).forEach( key => {
      data.input_values["input_" + key] = this.state.values[key];
    });

    this.props.gravityFormsApi
      .submit(this.props.formId,data)
      .then( response => response.json() )
      .then( ({ status, response }) => {
        if( status === 200 && response.is_valid ){
          this.setState(
            { values: {},
              valid: {},
              submitted: false,
              message: {
                info: "Form submitted successfully",
                success: true
              },
              sending: false
            },
            () => {
              Object.keys(this.inputRefs)
                .forEach( key => {
                  this.inputRefs[key].value = '';
                });
            }
          );
        } else {
          this.setState(
            {
              message: {
                info: "Error occurred while submitting form",
                success: false
              },
              sending: false
            }
          );
        }

      });
  }

  handleChange(event, field){
    const values = { ...this.state.values };
    const value = event.target.value;
    values[field.id] = value;

    this.setState(
      { values, message: null },
      () => {
        const valid = { ...this.state.valid };
        valid[field.id] = this.checkValidity(field);
        this.setState({ valid })
      }
    );
  }

  checkValidity(field){
    const value = this.state.values[field.id];

    if(field.isRequired && !value)
      return false;

    if(field.type === 'email'){
      return validateEmail(value);
    }

    return true;
  }

  render(){


    const form = this.state.fields && this.state.fields.map( f => {
      const half_row = {
        xs: "12",
        lg: "6"
      };

      const row = {
        xs: "12",
      };

      let colProps = null;

      switch (f.type){
        case 'textarea':
          colProps = row;
          break;
        default:
          colProps = half_row;
      }


      return (
        <Col key={f.id} { ...colProps } >
          <FormGroup>
            <Input type={f.type}
                   name={f.id}
                   id={f.id}
                   placeholder={f.placeholder}
                   value={this.state.values[f.id]}
                   onChange={ event => this.handleChange(event,f) }
                   valid={ !this.state.submitted || Boolean(this.state.valid[f.id]) }
                   innerRef={ el => {
                     this.inputRefs[f.id] = el;
                   } }/>
            <FormFeedback>* Required</FormFeedback>
          </FormGroup>
        </Col>
      );
    });

    return (
      <Form className={"basic-form " + this.props.className}>
        <Row>
          { form }
        </Row>
        {
          Boolean(this.state.message) &&
          <div className={ "form-info " + ( this.state.message.success ? this.props.success || "bg-success" : this.props.error || "bg-danger" )}>
            <span>{ this.state.message.info }</span>
          </div>
        }
        {
          this.state.sending &&
          <div className={"form-spinner-container"}>
            <Spinner/>
          </div>
        }
        <Button className="send-button" type={'button'} onClick={this.submit}>{ this.state.button ? this.state.button.text : 'Submit' }</Button>
      </Form>
    );
  }
}

export const BasicForm = connect(
  state => ({
    gravityFormsApi: state.gravityFormsApi
  })
)(BasicFormContainer);



// WEBPACK FOOTER //
// ./src/forms/BasicForm.js